import React from 'react';

const EstimatedContentsReplacementCostInfo = () => (
    <div style={{ overflow: 'auto', maxHeight: '60vh', fontSize: '1em' }}>
        <h2>What is the contents replacement value?</h2>
        <p>
            Contents replacement value is the total cost to replace all your
            belongings with new items of a similar type and quality if they
            were lost or damaged.
        </p>
        <p>
            This amount should reflect what it would cost today, not what you
            originally paid for the items.
        </p>
        <h2>What should be included?</h2>
        <p>
            When estimating your contents replacement value, include everything
            you could take with you if you moved house, such as:
        </p>
        <ul style={{ display: 'block', paddingLeft: '40px', listStyleType: 'disc' }}>
            <li>Furniture like sofas, beds, tables and outdoor furniture.</li>
            <li>Electrical items and appliances, including TVs, computers and kitchen appliances.</li>
            <li>Clothing, shoes and accessories.</li>
            <li>Jewellery, watches and personal valuables.</li>
            <li>Sporting equipment, tools and hobbies.</li>
            <li>Curtains, rugs and blinds.</li>
            <li>Kitchenware, linen and household items</li>
        </ul>
        <p>
            This should not include the building itself or fixtures that are
            permanently attached, such as walls, ceilings or built in
            cabinetry.
        </p>
    </div>
);

export default EstimatedContentsReplacementCostInfo;
